<style>
#networkReportModal .v--modal-box.v--modal {
  min-height: 400px !important;
  min-width: 680px !important;
}
#networkReportModal :not(.v-icon) {
  font-size: 12px;
}
#networkReportModal .area__wrapper {
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 5px;
}
#networkReportModal .area__wrapper span {
  text-transform: uppercase;
}
#networkReportModal .btn--area {
  margin-left: 5px;
}
#networkReportModal .area__wrapper--element {
  align-items: center;
  width: 100%;
}
#networkReportModal .v-form {
  margin-top: 10px;
}
#networkReportModal .icon-label {
  position: absolute;
  margin-top: 3px;
  margin-left: 5px;
}
#networkReportModal .v-subheader {
  font-size: 14px !important;
  color: #000 !important;
  font-weight: 600 !important;
}
#networkReportModal .required-field label::after {
  content: " *";
  color: red;
  font-size: 14px;
}
</style>

<template>
  <Modal
    modalName="networkReportModal"
    title="RAPORT O SIECI"
    @closed="clear"
    @report="getReport"
    :buttons="[ 'info', 'report']"
  >
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-layout row wrap>
        <v-subheader>ZASIĘG RAPORTU</v-subheader>
      </v-layout>
      <v-layout class="area__wrapper">
        <v-flex
          xs5
          v-show="!reportPayload.geometry"
        >
          <v-icon
            class="table__btn--green"
            title="Dodaj zasięg obszaru, dla którego zostanie wygenerowany raport"
            @click="addReportArea"
          >
            add_circle
          </v-icon>
          <span class="icon-label">Dodaj zasięg raportu</span>
        </v-flex>
        <v-flex
          xs5
          v-show="reportPayload.geometry"
        >
          <v-icon
            class="btn--area"
            title="Przybliż do obszaru raportu"
            @click="zoomToReportArea"
          >zoom_in</v-icon>
          <span class="icon-label">Przybliż do zasięgu raportu</span>
        </v-flex>
        <v-spacer />

        <v-flex
          xs5
          v-show="reportPayload.geometry"
        >
          <v-icon
            class="btn--area table__btn--red"
            title="Usuń zasięg raportu"
            @click="removeReportArea"
          >delete</v-icon>
          <span class="icon-label">Usuń zasięg raportu</span>

        </v-flex>

      </v-layout>
      <v-layout row wrap>
        <v-subheader>ATRYBUTY RAPORTU</v-subheader>
      </v-layout>
      <v-layout>
        <v-flex xs5>
          <v-select
            v-model="reportPayload.type"
            :rules="netRules"
            :items="netTypes"
            item-text="pl"
            item-value="en"
            label="Rodzaj sieci"
            required
            @change="delete reportPayload.net_type"
          >
          </v-select>
        </v-flex>
        <v-spacer />
        <v-flex xs5>
          <v-select
            v-model="formatBig"
            :rules="formatRules"
            :items="formats"
            label="Format raport"
            required
          >
          </v-select>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs5>
          <v-select
            class="required-field"
            v-model="reportPayload.net_type"
            :rules="net_typeRules"
            :items="netSubtypes"
            label="Podtyp sieci kanalizacyjnej"
            v-show="reportPayload.type === 'sewer'"
            required
          >
          </v-select>
        </v-flex>
      </v-layout>
    </v-form>

  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    reportPayload: {
      type: undefined,
      format: undefined,
      geometry: "",
      net_type: ""
    },
    formatBig: undefined,
    formats: [
      "PDF", "XLSX", "DOCX"
    ],
    formatRules: [v => !!v || "Wybierz format raportu"],
    netTypes: [
      {
        pl: "Sieć wodociągowa",
        en: 'water'
      },
      {
        pl: "Sieć kanalizacyjna",
        en: 'sewer'
      }
    ],
    netSubtypes: ['Kanalizacja ogólnospławna', 'Kanalizacja deszczowa', 'Kanalizacja sanitarna'],
    netRules: [v => !!v || "Wybierz typ sieci"],
    net_typeRules: [v => !!v || "Wybierz podtyp sieci"],
    valid: false,
  }),
  methods: {
    addReportArea() {
      this.$root.$emit(
        "showSnackbar",
        "#2a579a",
        "Kliknij na mapie, aby zacząć rysować obszar"
      );
      this.$root.$emit("addNewArea", 'networkReport');
    },
    addReportGeom(data) {
      if(data[2] === 'networkReport') this.reportPayload.geometry = data[0]
    },
    clear() {
      this.formatBig = '';
      this.removeReportArea();
      this.reportPayload = {};
    },
    getReport() {
      if (this.reportPayload.type != 'water' && !this.reportPayload.net_type) {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Określenie podtypu sieci kanalizacyjnej jest wymagane"
        );
        return;
      }
      this.reportPayload.format = this.formatBig.toLowerCase()
      this.$store.dispatch('networkReport', this.reportPayload).then(res => {
        if(!res) {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas pobierania raportu wystąpił błąd"
          );
        }
      })
    },
    removeReportArea() {
      this.reportPayload.geometry = ""
      this.$root.$emit("removeMapLayer");
    },
    zoomToReportArea() {
      this.$root.$emit("zoomToArea", [this.reportPayload.geometry.coordinates]);
    },

  },
  mounted() {
    this.$root.$on('newGeomAdded', this.addReportGeom)
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/start/modals/NetworkReport.vue